<script>
    export default {
        props: [
            'stat', 'getRoute',
            'initMaxRangeWeeks', 'initMainYearStart', 'initMainWeekStart', 'initMainYearEnd' , 'initMainWeekEnd',
            'initMainState', 'initMainActualizePast', 'initMainType',
            'initCompareYearStart', 'initCompareWeekStart', 'initCompareYearEnd' , 'initCompareWeekEnd',
            'initCompareState', 'initCompareActualizePast', 'initCompareType', 'initConsultantLevel'
        ],
        data() {
            return {
                maxRangeWeeks: this.initMaxRangeWeeks,
                mainYearStart: this.initMainYearStart,
                mainWeekStart: this.initMainWeekStart,
                mainYearEnd: this.initMainYearEnd,
                mainWeekEnd: this.initMainWeekEnd,
                mainState: this.initMainState,
                mainActualizePast: this.initMainActualizePast,
                mainNumWeeks: 0,
                mainType: this.initMainType,
                compareYearStart: this.initCompareYearStart,
                compareWeekStart: this.initCompareWeekStart,
                compareYearEnd: this.initCompareYearEnd,
                compareWeekEnd: this.initCompareWeekEnd,
                compareState: this.initCompareState,
                compareActualizePast: this.initCompareActualizePast,
                compareNumWeeks: 0,
                compareType: this.initCompareType,
                consultantId: this.consultantId,
                consultantLevel: this.initConsultantLevel,
                table: false,
            }
        },
        mounted: function(){
            let statisticFilter = this;

            statisticFilter.initListeners();

            statisticFilter.applyFilter();

            Event.$on('consultantLevelChanged', function (consultantLevel) {
                statisticFilter.consultantLevel = consultantLevel;
                statisticFilter.applyFilter();
            });

            Event.$on('tableDataFetch', function (statisticChart, event) {
                if(statisticFilter.stat == statisticChart.stat){
                    statisticFilter.tableFetch(event.target);
                }
            });

            Event.$emit('actualizePastChanged', statisticFilter);
        },
        methods: {
            initListeners: function () {
                let statisticFilter = this;

                $(document).ready(function(){
                    //main
                    $("[name='main_actualize_past']", statisticFilter.$el).next(".ios-ui-select").on("click", function(event, triggered){
                        if(!triggered){
                            $("[name='compare_actualize_past']", statisticFilter.$el).next(".ios-ui-select").trigger("click", [true]);
                        }
                        Event.$emit('actualizePastChanged', statisticFilter);
                    });

                    $(statisticFilter.$el).on("change", "[name='main_year_start']", function(){
                        statisticFilter.mainYearStart = Number($(this).val());
                        statisticFilter.calcNumWeeks();
                    });

                    $(statisticFilter.$el).on("change", "[name='main_week_start']", function(){
                        statisticFilter.mainWeekStart = Number($(this).val());
                        statisticFilter.calcNumWeeks();
                    });

                    $(statisticFilter.$el).on("change", "[name='main_year_end']", function(){
                        statisticFilter.mainYearEnd = Number($(this).val());
                        statisticFilter.calcNumWeeks();
                    });

                    $(statisticFilter.$el).on("change", "[name='main_week_end']", function(){
                        statisticFilter.mainWeekEnd = Number($(this).val());
                        statisticFilter.calcNumWeeks();
                    });

                    $(statisticFilter.$el).on("change", "[name='main_type']", function(){
                        statisticFilter.mainType = $(this).val();
                    });

                    $(statisticFilter.$el).on("change", "[name='main_state']", function(){
                        statisticFilter.mainState = $(this).val();
                    });

                    //compare
                    $("[name='compare_actualize_past']", statisticFilter.$el).next(".ios-ui-select").on("click", function(event, triggered){
                        if(!triggered){
                            $("[name='main_actualize_past']", statisticFilter.$el).next(".ios-ui-select").trigger("click", [true]);
                        }
                        Event.$emit('actualizePastChanged', statisticFilter);
                    });

                    $(statisticFilter.$el).on("change", "[name='compare_year_start']", function(){
                        statisticFilter.compareYearStart = Number($(this).val());
                        statisticFilter.calcNumWeeks();
                    });

                    $(statisticFilter.$el).on("change", "[name='compare_week_start']", function(){
                        statisticFilter.compareWeekStart = Number($(this).val());
                        statisticFilter.calcNumWeeks();
                    });

                    $(statisticFilter.$el).on("change", "[name='compare_year_end']", function(){
                        statisticFilter.compareYearEnd = Number($(this).val());
                        statisticFilter.calcNumWeeks();
                    });

                    $(statisticFilter.$el).on("change", "[name='compare_week_end']", function(){
                        statisticFilter.compareWeekEnd = Number($(this).val());
                        statisticFilter.calcNumWeeks();
                    });

                    $(statisticFilter.$el).on("change", "[name='compare_type']", function(){
                        statisticFilter.compareType = $(this).val();
                    });

                    $(statisticFilter.$el).on("change", "[name='compare_state']", function(){
                        statisticFilter.compareState = $(this).val();
                    });
                });

            },
            tableFetch: function(element){
                let statisticFilter = this;

                if($(element).attr("aria-expanded") == undefined || $(element).attr("aria-expanded") == "false"){
                    statisticFilter.table = true;
                    statisticFilter.applyFilter();
                }else{
                    statisticFilter.table = false;
                }
            },
            applyFilter: function () {
                let statisticFilter = this;

                statisticFilter.calcNumWeeks();

                if(statisticFilter.mainNumWeeks != statisticFilter.compareNumWeeks){
                    swal(_t('The N° weeks in the two filters must be equal to apply the filter!') , {
                        buttons: {
                            cancel: {
                                text: alertCancelButtonTrans,
                                value: null,
                                visible: true,
                                className: "btn btn-danger"
                            },
                        },
                        icon: "error",
                        dangerMode: true
                    });
                }else if(statisticFilter.mainNumWeeks > statisticFilter.maxRangeWeeks){
                    swal(_t('The maximum range permitted is :weeks weeks', {weeks: statisticFilter.maxRangeWeeks}) , {
                        buttons: {
                            cancel: {
                                text: alertCancelButtonTrans,
                                value: null,
                                visible: true,
                                className: "btn btn-danger"
                            },
                        },
                        icon: "error",
                        dangerMode: true
                    });
                }else{
                    statisticFilter.$parent.loading = true;

                    //TODO AJAX CALL AND EMIT EVENT ON RESPONSE WITH NEW DATA
                    axios.get(this.getRoute, {
                            params: {
                                statistic: statisticFilter.stat,
                                mainType: statisticFilter.mainType,
                                mainYearStart: statisticFilter.mainYearStart,
                                mainWeekStart: statisticFilter.mainWeekStart,
                                mainYearEnd: statisticFilter.mainYearEnd,
                                mainWeekEnd: statisticFilter.mainWeekEnd,
                                mainState: statisticFilter.mainState,
                                mainActualizePast: statisticFilter.mainActualizePast,
                                compareType: statisticFilter.compareType,
                                compareYearStart: statisticFilter.compareYearStart,
                                compareWeekStart: statisticFilter.compareWeekStart,
                                compareYearEnd: statisticFilter.compareYearEnd,
                                compareWeekEnd: statisticFilter.compareWeekEnd,
                                compareState: statisticFilter.compareState,
                                compareActualizePast: statisticFilter.compareActualizePast,
                                consultantLevel: statisticFilter.consultantLevel,
                                table: statisticFilter.table,
                            }
                        })
                        .then((res) => {
                            let data = res.data.data;
                            Event.$emit('filterApplied', statisticFilter, data);
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                }

            },
            calcNumWeeks: function () {
                let statisticFilter = this;

                statisticFilter.mainNumWeeks = 0;
                for(let year = statisticFilter.mainYearStart; year <= statisticFilter.mainYearEnd; year++){
                    let week_start = 1;
                    let week_end = 52;
                    if(year == statisticFilter.mainYearStart){
                        week_start = statisticFilter.mainWeekStart;
                    }
                    if(year == statisticFilter.mainYearEnd){
                        week_end = statisticFilter.mainWeekEnd;
                    }
                    for(let week = week_start; week <= week_end; week++){
                        statisticFilter.mainNumWeeks++;
                    }
                }

                statisticFilter.compareNumWeeks = 0;
                for(let year = statisticFilter.compareYearStart; year <= statisticFilter.compareYearEnd; year++){
                    let week_start = 1;
                    let week_end = 52;
                    if(year == statisticFilter.compareYearStart){
                        week_start = statisticFilter.compareWeekStart;
                    }
                    if(year == statisticFilter.compareYearEnd){
                        week_end = statisticFilter.compareWeekEnd;
                    }
                    for(let week = week_start; week <= week_end; week++){
                        statisticFilter.compareNumWeeks++;
                    }
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/app/components/widgets/statistics/statisticFilter.vue